import datepickerFactory from "jquery-datepicker";

// Initialize datepicker factory
datepickerFactory($);

// Define regional settings for all supported languages
var regionalSettings = {
  'sv': {
    closeText: 'Stäng',
    prevText: '&#xAB;Förra',
    nextText: 'Nästa&#xBB;',
    currentText: 'Idag',
    monthNames: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    dayNamesShort: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
    dayNames: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
    dayNamesMin: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
    weekHeader: 'Ve',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  },
  'no': {
    closeText: 'Lukk',
    prevText: '&#xAB;Forrige',
    nextText: 'Neste&#xBB;',
    currentText: 'I dag',
    monthNames: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
    dayNamesShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    dayNames: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
    dayNamesMin: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
    weekHeader: 'Uke',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  },
  'da': {
    closeText: 'Luk',
    prevText: '&#xAB;Forrige',
    nextText: 'Næste&#xBB;',
    currentText: 'I dag',
    monthNames: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
    dayNamesShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    dayNames: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
    dayNamesMin: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
    weekHeader: 'Uge',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  },
  'fi': {
    closeText: 'Sulje',
    prevText: '&#xAB;Edellinen',
    nextText: 'Seuraava&#xBB;',
    currentText: 'Tänään',
    monthNames: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
    monthNamesShort: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
    dayNamesShort: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
    dayNames: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
    dayNamesMin: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
    weekHeader: 'Vk',
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  },
  'en': {
    closeText: 'Done',
    prevText: '&#xAB;Prev',
    nextText: 'Next&#xBB;',
    currentText: 'Today',
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    weekHeader: 'Wk',
    dateFormat: 'dd/mm/yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  }
};

// Map siteLang to regional code
var regionalMap = {
  'NO': 'no',
  'SV': 'sv',
  'DK': 'da',
  'FI': 'fi',
  'EN': 'en'
};

// Get regional code, fallback to Swedish (primary language)
var regionalCode = regionalMap[siteLang] || 'sv';
var settings = regionalSettings[regionalCode];

// Register the regional settings with jQuery datepicker for global use
$.datepicker.regional[regionalCode] = settings;
$.datepicker.setDefaults(settings);

// Initialize all datepicker inputs on the page
$(function() {
  $("#datepicker").datepicker(settings);
});
